<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="mb-3">
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="domain"
              :label="$t('domainName')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              placeholder="abriron.com"
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="webziApiKey"
              :label="$t('apiKey')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="rate"
              :label="$t('currencyRate')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-chip
              v-clipboard:copy="hashkey"
              label
              dark
              color="green"
              link
              @click="copied"
            >
              {{ $t('orderWebhook') }} : {{ hashkey }}
              <v-icon class="mx-2">
                mdi-content-copy
              </v-icon>
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="registerStatus"
              :label="$t('registerStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="updateStatus"
              :label="$t('updateStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="removeStatus"
              :label="$t('removeStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="returnSellStatus"
              :label="$t('returnSellStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              :title="$t('entrepotToUse')"
              type="entrepot"
              :outlined="true"
              :value="entrepot"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="webziBranch"
              :title="$t('defaultBranch')"
              type="branch"
              :outlined="true"
              :value="branch"
            />
          </v-col>
          <v-col md="3">
            <v-checkbox
              v-model="webziUpdateStock"
              class="mt-0"
              :label="$t('updateStock')"
              value="yes"
            />
          </v-col>
          <v-col md="3">
            <v-checkbox
              v-model="webziUpdatePrice"
              class="mt-0"
              :label="$t('updatePrice')"
              value="yes"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="px-3"
          >
            <v-btn
              color="green"
              class="mr-0"
              small
              @click="addPaymentMethod"
            >
              {{ $t('addPeymentMethod') }}
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col
            v-for="(item, index) in paymentItems"
            :key="index"
            cols="12"
            class="d-flex pa-0"
          >
            <v-col
              cols="5"
            >
              <autocomplete
                v-model="item.bank"
                :title="$t('bank') + '/' + $t('cash')"
                type="allBankCash"
                :rules="[v => !!v || $t('is-required')]"
                :outlined="true"
                :value="item.bank"
              />
            </v-col>
            <v-col
              cols="6"
            >
              <v-select
                v-model="item.value"
                :label="$t('method')"
                :items="paymentMethods"
                height="30"
                dense
                outlined
                clearable
                item-value="value"
                item-text="text"
              />
            </v-col>
            <v-col
              cols="6"
            >
              <v-btn
                x-small
                class="mt-1"
                icon
                @click="remove(index)"
              >
                <v-icon color="pink">
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
  import autocomplete from '../../components/general/patial/autocomplete'
  import General from '../../../../Mixins/general'
  export default {
    name: 'Customer',
    components: {
      // aicomplete,
      autocomplete,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      hashkey: null,
      webziBranch: null,
      updatePrice: null,
      webziApiKey: null,
      updateStock: null,
      updateStatus: null,
      returnSellStatus: null,
      removeStatus: null,
      registerStatus: null,
      webziUpdatePrice: null,
      webziUpdateStock: null,
      entrepot: null,
      entrepotEdit: null,
      username: null,
      paymentItems: [],
      paymentMethods: [],
      rate: null,
      password: null,
      domain: null,
      type: null,
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.statusItems = [
        {
          value: '1',
          text: this.$t('pendingReview'),
        },
        {
          value: '2',
          text: this.$t('orderConfirmed'),
        },
        {
          value: '3',
          text: this.$t('orderCompleted'),
        },
        {
          value: '4',
          text: this.$t('awaitingStockCompletion'),
        },
        {
          value: '5',
          text: this.$t('shipped'),
        },
        {
          value: '6',
          text: this.$t('delivered'),
        },
        {
          value: '7',
          text: this.$t('cancelled'),
        },
        {
          value: '8',
          text: this.$t('refunded'),
        },
        {
          value: '9',
          text: this.$t('paymentConfirmed'),
        },
        {
          value: '10',
          text: this.$t('paymentError'),
        },
        {
          value: '11',
          text: this.$t('awaitingPayment'),
        },
      ]
      this.paymentMethods = [
        {
          value: 'parsian',
          text: this.$t('parsian'),
        },
        {
          value: 'payping',
          text: this.$t('payping'),
        },
        {
          value: 'saman',
          text: this.$t('saman'),
        },
        {
          value: 'melat',
          text: this.$t('melat'),
        },
        {
          value: 'meli',
          text: this.$t('meli'),
        },
        {
          value: 'pasargard',
          text: this.$t('pasargard'),
        },
        {
          value: 'sama',
          text: this.$t('sama'),
        },
        {
          value: 'toman',
          text: this.$t('toman'),
        },
        {
          value: 'sepehr',
          text: this.$t('sepehr'),
        },
        {
          value: 'pay_ir',
          text: this.$t('pay_ir'),
        },
        {
          value: 'vandar',
          text: this.$t('vandar'),
        },
        {
          value: 'id_pay',
          text: this.$t('id_pay'),
        },
        {
          value: 'zibal',
          text: this.$t('zibal'),
        },
        {
          value: 'zarinpal',
          text: this.$t('zarinpal'),
        },
        {
          value: 'ezpay',
          text: this.$t('ezpay'),
        },
        {
          value: 'aghaye_pardakht',
          text: this.$t('aghaye_pardakht'),
        },
        {
          value: 'asan_pardakht',
          text: this.$t('asan_pardakht'),
        },
        {
          value: 'walleta',
          text: this.$t('walleta'),
        },
        {
          value: 'snapp_pay',
          text: this.$t('snapp_pay'),
        },
      ]
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'webzi', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'webzi', {
          params: {
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.entrepot = res.entrepot
              app.webziApiKey = res.webziApiKey
              app.domain = res.webziDomain
              app.webziUpdateStock = res.webziUpdateStock
              app.webziUpdatePrice = res.webziUpdatePrice
              app.webziBranch = res.webziBranch
              app.updateStatus = res.webziUpdateStatus
              app.returnSellStatus = res.webziReturnSellStatus
              app.registerStatus = res.webziRegisterStatus
              app.removeStatus = res.webziRemoveStatus
              app.paymentItems = res.webziPaymentItems
              app.rate = res.webziCurrencyRate
              app.hashkey = 'https://src.abriron.com/api/order/webzi?abrkey=' + res.hashkey
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
